import { dictionary } from 'common/language/dictionary';
import { I18nNamespace } from 'common/language/namespace';

export const AutomationRecursiveCrawlInputI18n = {
  configuration: { namespace: I18nNamespace.AUTOMATION_RECURSIVE_CRAWL_INPUT, labelKey: 'label' },
  translations: {
    label: dictionary.recursiveCrawl,
  },
};
